import $ from "jquery";
import debug from "bows";

const log = debug("nav");
const navToggles = $('.nav-mobile__btn');
const btnMM = $('.btn-mm');
const navMobile = $('.nav-mobile');

function toggleNav() {
	let $this = $(this);
	$this.toggleClass('nav-mobile__btn--active');
	$this.siblings('.nav-mobile__list').slideToggle();
}

function toggleMobile() {
	let $this = $(this);
	$this.toggleClass('btn-mm--active');
	navMobile.slideToggle();
}

export function init() {
	if (navToggles.length) {
		navToggles.on('click', toggleNav);
	}

	if (btnMM.length) {
		btnMM.on('click', toggleMobile);
	}
}

export default {
	init
};
